<template>
  <div class="detail-container">
    <template v-for="(item, index) in configArray">
      <div
        :key="index"
        v-if="item.display == undefined ? true : item.display ? true : ''"
        class="item-one"
        :class="item.span ? `col-${item.span}` : 'col-8'"
      >
        <div
          class="item-label"
          :style="{ 'min-width': item.label ? '150px' : '0', 'text-align':textAlign?textAlign:'right' }"
        >
        <span v-if="item.required" style="color: red"> * </span> {{ item.label }}{{ item.label ? ":" : "" }}
        </div>
        <template v-if="item.slot">
          <slot :name="item.prop"> </slot>
        </template>
        <template v-else>
          <template v-if="!item.type">
            <div
              class="item-value"
              v-if="showNull"
              :style="{ color: item.color ? item.color : '' }"
            >
              无
            </div>
            <div
              class="item-value"
              v-else
              :style="{ color: item.color ? item.color : '' }"
            >
             
              {{
                initValue[item.prop.trim()] === undefined ||initValue[item.prop.trim()] === ""
                  ? "无"
                  : item.formatter
                  ? item.formatter(item.label, item.propInner?initValue[item.prop.trim()][item.propInner]:initValue[item.prop.trim()])
                  : item.unit
                  ? `${item.propInner?initValue[item.prop.trim()][item.propInner]:initValue[item.prop.trim()]}${item.unit}`
                  : item.propInner?initValue[item.prop.trim()][item.propInner]:initValue[item.prop.trim()]
              }}
            </div>
          </template>
          <el-input
            class="input-item"
            :disabled="item.disabled"
            v-if="item.type == 'input'"
            v-model="initValue[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-input
            class="input-item"
            :disabled="item.disabled"
            v-if="item.type == 'textarea'"
            type="textarea"
            :autosize="{ minRows: 4 }"
            v-model="initValue[item.prop]"
            :placeholder="item.placeholder"
          ></el-input>
          <el-date-picker
            style="width:100%"
            :disabled="item.disabled"
            v-if="item.typeState == 'date'"
            type="date"
            :clearable="item.clearable?item.clearable:true"
            :autosize="{ minRows: 4 }"
            v-model="initValue[item.prop]"
            :placeholder="item.placeholder"
          ></el-date-picker>
        </template>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: "CommonDetail",
  data() {
    return {};
  },
  watch: {
    initValue: {
      handler(newData, oldData) {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  props: {
    textAlign: {
      type: String,
      default: 'right'
    },
    configArray: {
      type: Array,
      required: true,
    },
    initValue: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 若为true， 全部显示为空
    showNull: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.detail-container {
  display: flex;
  flex-wrap: wrap;
  .item-one {
    line-height: 45px;
    display: flex;
    align-items: center;
    padding-bottom: 8px;
    .input-item {
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .item-label {
      font-weight: 700;
      font-style: normal;
      color: #999999;
      // text-align: right;
      min-width: 150px;
      padding-right: 12px;
    }
    .item-value {
      font-size: 13px;
      font-weight: 400;
      color: #333;
      flex: 1;
      line-height: 28px;
    }
  }
  .col-6 {
    width: 25%;
  }
  .col-8 {
    width: 33.3%;
  }
  .col-12 {
    width: 50%;
  }
  .col-14 {
    width: 58.33333%;
  }
  .col-16 {
    width: 66.6%;
  }
  .col-18 {
    width: 75%;
  }
  .col-24 {
    width: 100%;
  }
}
</style>